import { ValueType } from "./ValueType";

export default class Value {
    /**
     * @param {string} id 
     */
    constructor(id) {
        /**
         * @constant
         * @type {string}
         */
        this.id = id;
    }

    /**
     * @abstract
     */
    reset() {}

    /**
     * @abstract
     * @returns {number}
     */
    getValueType() {
        return ValueType.BIG_NUM;
    }

    /**
     * @abstract
     * @returns {boolean}
     */
    isAtInitialValue() {
        return true;
    }

    /**
     * @abstract
     * @returns {boolean}
     */
    isValueApplicable() {
        return true;
    }
}
